/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReinclusaoBeneficiarioAliases {
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_9 = 'autocomplete-9',
  CHECKLIST_DEPENDENTE = 'checklist-dependente',
  CONTEXTUAL_BAR_REINCLUSAO_BENEF = 'contextual-bar-reinclusao-benef',
  FETCH_CIDADE = 'fetch-cidade',
  FETCH_ESTADO = 'fetch-estado',
  FETCH_LOGRADOURO = 'fetch-logradouro',
  FIELD_ANEXO = 'field-anexo',
  FIELD_BAIRRO = 'field-bairro',
  FIELD_CELULAR = 'field-celular',
  FIELD_CEP = 'field-cep',
  FIELD_CIDADE = 'field-cidade',
  FIELD_COMPLEMENTO = 'field-complemento',
  FIELD_DEPENDENTE = 'field-dependente',
  FIELD_ENDERECO = 'field-endereco',
  FIELD_ESTADO = 'field-estado',
  FIELD_LOGRADOURO = 'field-logradouro',
  FIELD_NOME_TITULAR = 'field-nome-titular',
  FIELD_NUMERO = 'field-numero',
  FIELD_TELEFONE = 'field-telefone',
  FILE_UPLOADER_ANEXO = 'file-uploader-anexo',
  FORM_ANEXO = 'form-anexo',
  FORM_DEPENDENTE = 'form-dependente',
  FORM_TITULAR = 'form-titular',
  INPUT_BAIRRO = 'input-bairro',
  INPUT_CEP = 'input-cep',
  INPUT_COMPLEMENTO = 'input-complemento',
  INPUT_ENDERECO = 'input-endereco',
  INPUT_NUMERO = 'input-numero',
  LAYOUT_0 = 'layout-0',
  LAYOUT_REINCLUSAO_BENEF = 'layout-reinclusao-benef',
  MAPPER_21 = 'mapper-21',
  MAPPER_ANEXO = 'mapper-anexo',
  MAPPER_CIDADE = 'mapper-cidade',
  MAPPER_ESTADO = 'mapper-estado',
  PANEL_ANEXO = 'panel-anexo',
  PANEL_REINCLUSAO_BENEF = 'panel-reinclusao-benef',
  PHONE_CELULAR = 'phone-celular',
  PHONE_TELEFONE = 'phone-telefone',
  TEXT_21 = 'text-21',
  TEXT_CIDADE = 'text-cidade',
  TEXT_ESTADO = 'text-estado',
  TEXT_NOME_TITULAR = 'text-nome-titular',
  UNBOXED_AUTOCOMPLETE_CIDADE = 'unboxed-autocomplete-cidade',
  UNBOXED_AUTOCOMPLETE_ESTADO = 'unboxed-autocomplete-estado',
  WIZARD_REINCLUSAO = 'wizard-reinclusao',
  WIZARD_STEP_ANEXO = 'wizard-step-anexo',
  WIZARD_STEP_DEPENDENTE = 'wizard-step-dependente',
  WIZARD_STEP_TITULAR = 'wizard-step-titular',
}
export { ReinclusaoBeneficiarioAliases };
